import React from 'react';
import { Skeleton } from '@mui/material';
import shortid from 'shortid';

export const SkeletonTable = ({ columns = 4 }) => (
  <tr>
    {[...Array(columns).keys()].map(() => (
      <td key={shortid.generate()}>
        <Skeleton
                style={{ height: '30px', width: '80%', margin: '6px' }}
                variant="rectangular"
                width="75%"
            />
      </td>
      ))}
  </tr>
);
